import { LifecycleType } from "./generated";

export const reactivatableLifecycleTypes: LifecycleType[] = [
  LifecycleType.Trial,
  LifecycleType.Paid,
  LifecycleType.Evergreen,
];
